export default "__VITE_ASSET__CFfKYPmH__"